import axios from "axios";
// import retrieveToken from "./authRequests/retrieveTokens";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  withCredentials: true,
  timeout: 60000 * 5,
});
